import axiosWrapper from './axiosWrapper'

const URL_PROVINCIA = `api/provincias`

const getProvincias = (axiosParams) => {
  const url = `${axiosParams.baseURL}/${URL_PROVINCIA}`
  return axiosWrapper.post({ ...axiosParams, url })
}

const serviceProvincia = {
  getProvincias
}

export default serviceProvincia
